import { render, staticRenderFns } from "./academicDegreeRecord.vue?vue&type=template&id=f14386d4&scoped=true"
import script from "./academicDegreeRecord.vue?vue&type=script&lang=js"
export * from "./academicDegreeRecord.vue?vue&type=script&lang=js"
import style0 from "./academicDegreeRecord.vue?vue&type=style&index=0&id=f14386d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14386d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f14386d4')) {
      api.createRecord('f14386d4', component.options)
    } else {
      api.reload('f14386d4', component.options)
    }
    module.hot.accept("./academicDegreeRecord.vue?vue&type=template&id=f14386d4&scoped=true", function () {
      api.rerender('f14386d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/academicDegree/academicDegreeRecord.vue"
export default component.exports